module.exports = __webpack_public_path__ + "fonts/Kostic-Roc-Grotesk-Regular.39c9776.otf";